import * as React from 'react';
import Switch from './Switch';

import { ADMIN, AJPIS, ASSOCIATION, BACK_OFFICE, CITY_HALL, CRC } from '../constants/accountType';

/** Middleware */
import AuthRoute from './middlewares/AuthRoute';
import PublicRoute from './middlewares/PublicRoute';

import Dashboard from '../containers/Dashboard';

import AdminBlockMonth from '../containers/AdminBlockMonth';
import AdminExportBeneficiary from '../containers/AdminExportBeneficiary';
import AssociationAdministration from '../containers/AssociationAdministration';
import AssociationAids from '../containers/AssociationAids';
import AdditionBackOfficeAssociation from '../containers/BackOfficeAssociation/BackOfficeAdditionAssociation';
import BackOfficeAssociation from '../containers/BackOfficeAssociation';
import BackOfficeComputation from '../containers/BackOfficeComputation';
import BackOfficeSearch from '../containers/BackOfficeSearch';
import BeneficiaryAdd from '../containers/BeneficiaryAdd';
import BeneficiarySearch from '../containers/BeneficiarySearch';
import BeneficiarySearchAddition from '../containers/BeneficiarySearch/BeneficiarySearchAddition';
import BillAids from '../containers/BillAids';
import BilledAidsHistory from '../containers/BilledAidsHistory';
import ExportPartner from '../containers/ExportPartner';
import {
  FileImportAddition,
  FileImportAdditionAJPIS,
  FileImportAid,
  FileImportAidAJPIS
} from '../containers/FileImport';
import Login from '../containers/Login';
import PaymentsReports from '../containers/PaymentsReports';
import PaymentsReportsAddition from '../containers/PaymentsReports/PaymentsReportsAddition';
import Report from '../containers/Report';
import ResetPassword from '../containers/ResetPassword';
import UserAccount from '../containers/UserAccount';

import { store } from './configureStore';
import BeneficiaryAddAddition from '../containers/BeneficiaryAdd/BeneficiaryAddAddition';
import { Routes } from '../constants/routes';
import AdminExportPartner from '../containers/AdminExportPartner';
import { isAccountType } from '../lib/user';
import BillAdditions from '../containers/BillAdditions';
import BackOfficeAdditionComputation from '../containers/BackOfficeComputation/BackOfficeAdditionConsumption';
import AssociationAdditions from '../containers/AssociationAids/AssociationAdditions';

class CustomRouter extends React.Component<Route.ICustomRouteProps, Route.ICustomRouteState> {
  state = store.getState();
  subscription = store.subscribe(() => this.setState(store.getState()));

  componentWillUnmount() {
    this.subscription();
  }

  _isAccountType = (accountTypeName: string) => isAccountType(accountTypeName, this.state.Auth);

  render() {
    return (
      <Switch>
        {/* Private Route */}

        <AuthRoute path={Routes.Account} component={UserAccount} />

        {(this._isAccountType(BACK_OFFICE) || this._isAccountType(CITY_HALL) || this._isAccountType(ADMIN)) && (
          <React.Fragment>
            <AuthRoute path={Routes.AssociationAid} component={AssociationAids} />
            <AuthRoute path={Routes.AssociationAddition} component={AssociationAdditions} />
            <AuthRoute path={Routes.Aid} component={BeneficiaryAdd} />
            <AuthRoute path={Routes.AidsSearch} component={BeneficiarySearch} />
            <AuthRoute path={Routes.Addition} component={BeneficiaryAddAddition} />
            <AuthRoute path={Routes.AdditionSearch} component={BeneficiarySearchAddition} />
            <AuthRoute path={Routes.PaymentReports} component={PaymentsReports} />
            <AuthRoute path={Routes.PaymentReportsAddition} component={PaymentsReportsAddition} />
            <AuthRoute path={Routes.Report} component={Report} />
          </React.Fragment>
        )}

        {/* Admin */}
        {this._isAccountType(ADMIN) && (
          <React.Fragment>
            <AuthRoute path={Routes.PartnerExport} component={AdminExportPartner} />
            <AuthRoute path={Routes.BlockMonth} component={AdminBlockMonth} />
            <AuthRoute path={Routes.BillAdditions} component={BillAdditions} />
            <AuthRoute path={Routes.BillAids} component={BillAids} />
            <AuthRoute path={Routes.Export} component={AdminExportBeneficiary} />
          </React.Fragment>
        )}

        {/* Association */}
        {this._isAccountType(ASSOCIATION) && (
          <React.Fragment>
            <AuthRoute path={Routes.HomePage} component={AssociationAdministration} />
          </React.Fragment>
        )}

        {/* AJPIS / CRC */}
        {(this._isAccountType(AJPIS) || this._isAccountType(CRC) || this._isAccountType(ADMIN)) && (
          <React.Fragment>
            <AuthRoute path={Routes.PaymentReports} component={PaymentsReports} />
            <AuthRoute path={Routes.PaymentReportsAddition} component={PaymentsReportsAddition} />
            <AuthRoute path={this._isAccountType(ADMIN) ? Routes.History : Routes.HomePage}
                       component={BilledAidsHistory} />
          </React.Fragment>
        )}

        {/* Back Office */}
        {(this._isAccountType(BACK_OFFICE) || this._isAccountType(ADMIN)) && (
          <React.Fragment>
            <AuthRoute path={Routes.BackOfficeAdditionAssociation} component={AdditionBackOfficeAssociation} />
            <AuthRoute path={Routes.BackOfficeAssociation} component={BackOfficeAssociation} />
            <AuthRoute path={Routes.BackOfficeAdditionComputation} component={BackOfficeAdditionComputation} />
            <AuthRoute path={Routes.BackOfficeComputation} component={BackOfficeComputation} />
            <AuthRoute path={this._isAccountType(ADMIN) ? Routes.Search : Routes.HomePage}
                       component={BackOfficeSearch} />
          </React.Fragment>
        )}

        {/* City Hall */}
        {this._isAccountType(CITY_HALL) && <React.Fragment>
          <AuthRoute path={Routes.PartnerExport} component={ExportPartner} />
        </React.Fragment>}
        {(this._isAccountType(CITY_HALL) || this._isAccountType(ADMIN)) && (
          <React.Fragment>
            <AuthRoute path={Routes.FileImportAdditions} component={FileImportAddition} />
            <AuthRoute path={Routes.FileImport} component={FileImportAid} />
            <AuthRoute path={Routes.FileImportAdditionsAJPIS} component={FileImportAdditionAJPIS} />
            <AuthRoute path={Routes.FileImportAJPIS} component={FileImportAidAJPIS} />
            <AuthRoute path={Routes.HomePage} component={Dashboard} />
          </React.Fragment>
        )}

        {/* Public Route */}
        <PublicRoute path={Routes.ForgetPassword} exact component={ResetPassword} />
        <PublicRoute path={Routes.LoginPath} exact component={Login} />
      </Switch>
    );
  }
}

export default CustomRouter;
